import { createReducer } from '@reduxjs/toolkit'

import { ssoErrorOccurred, ssoRendered } from '../actions/actions'

const initialState = { rendered: false, errorOccurred: false }

const sso = createReducer(initialState, {
  [ssoRendered]: state => {
    state.errorOccurred = false
    state.rendered = true
  },
  [ssoErrorOccurred]: state => {
    state.errorOccurred = true
  }
})

export default sso
